<template>
    <div class="modify-nickname" v-if="value">
        <app-header @go-back="handleGoBack" hideNavIcon></app-header>
        <div class="body-padding">
            <cus-field placeholder="请在这里输入昵称" v-model="nickname"></cus-field>
            <div class="wrap-btn">
                <van-button type="warning" round :disabled="!nickname" @click="handleSave">保存</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModifyNickname",
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                nickname: ''
            }
        },
        components: {
            AppHeader: () => import('@/components/common/header/Header')
        },
        methods: {
            handleGoBack() {
                this.$emit('input', !this.value)
            },
            handleSave() {
                let params = {
                    mobile: this.$store.state.mobile,
                    nickname: this.nickname,
                    loginType: 5
                }
                this.$toast.loading({
                    message: '加载中...',
                    duration: 0,
                    forbidClick: true,
                    mask: true
                })
                this.$axios({
                    url: 'user/nickname',
                    method: 'post',
                    header: {
                        contentType: 'multipart/form-data;charset=utf8'
                    },
                    params
                }).then(() => {
                    this.$toast.clear()
                    this.$toast({
                        message: '修改成功',
                        duration: 1000
                    })
                    this.$emit('success')
                }).catch(err => {
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.modify-nickname {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #e5e5e5;
}
.wrap-btn {
    margin-top: 0.49rem;
    text-align: center;
}
</style>
